import { Injectable } from '@angular/core';
import { AbstractControl,ValidatorFn } from '@angular/forms';

@Injectable()
export class NumberRangeValidators {

    validateRange(min:number, max:number): ValidatorFn  {
        return (control: AbstractControl): { [key: string]: any } => {
            if((control.value != null) && (control.value != ''))
            {
                if(min!=null && control.value<min)
                {
                    return { 'invalidNumber': { range: { min: min, max: max } } };
                }
                if(max!=null && control.value>max)
                {
                    return { 'invalidNumber': { range: { min: min, max: max } } };
                }
            }
            return null;
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/exa/_validators/number-range-validators.ts